import { CERolePermissionAttributesBase } from './ce-role-permission-attributes-base'


export class CERolePermissionAttributes extends CERolePermissionAttributesBase {

}